import request from '@/utils/request'

/**
 * 读取终端SD卡目录
 * @param {*} data
 */
function getTerminalDir(terminal) {
  return request({
    url: `/terminal/debug/directory/${terminal}`,
    method: 'get'
  })
}

/**
 * 下载文件
 * @param {*} data
 */
function downloadFile(data) {
  return request({
    url: '/terminal/debug/download',
    method: 'post',
    data
  })
}

/**
 * Shell指令
 * @param {*} data
 */
function shellInput(data) {
  return request({
    url: '/terminal/debug/shell',
    method: 'post',
    data
  })
}


export {
  getTerminalDir,
  downloadFile,
  shellInput
}